import { GENDER_OPTIONS, PATIENT_STATUS, TODAY_DATE } from 'Common/Constants';
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
import CustomLabel from 'Common/CustomLabel/CustomLabel';
import Dropdown from 'Common/DropDown/Dropdown';
import ExportExcel from 'Components/ExportExcel/ExportExcel';
import PatientFilterSuperSearch from 'Components/PatientFilterSuperSearch/PatientFilterSuperSearch'
import Show from 'Components/Show/Show';
import SuperAccordion from 'Components/SuperAccordion/SuperAccordion';
import api from 'http';
import CreateTaskPopup from 'MainTabs/Tasks/Taskpopups/CreateTaskPopup';
import AddNewTagPopup from 'Popups/AddNewTagPopup/AddNewTagPopup';
import ConfirmationPopup from 'Popups/ConfirmationPopup/ConfirmationPopup';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { addPatient } from 'Redux/TabsSlice/TabsSlice';
import ParamListGen from 'Services/ParamListGen';
import PlusIcon from 'SVGS/PlusIcon';
import { FiChevronDown } from 'react-icons/fi';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import Select from 'react-select';
import CustomInput from 'Common/CustomInput/CustomInput';
import CustomSelect from "Common/CustomSelect/CustomSelect";
import CustomDateRangePicker from 'Common/CustomDateRangePicker/CustomDateRangePicker';
import MaskPhoneNumber from 'Utils/MaskPhoneNumber';
import ExportToEmail from 'Components/ExportToEmail/ExportToEmail';
import CustomReactSelectOptions from 'NewComponents/UiComponents/CustomReactSelectOptions';
import AccountNumSuperSearch from 'NewComponents/UtilityComponents/AccountNumSuperSearch/AccountNumSuperSearch';

const PatientSearchForm = ({
  parentTab = '',
  setPatientSuperSearchId,
  filterCount,
  selectedRows,
  searchModel,
  paramModel,
  setNewPatientPopup,
  taskRowsData,
  setLoading,
  handleSearchPatient,
  handleSearchModel,
  handleEnter,
  validationModel,
  onPasteZip,
  activeTab,
  handlemultiSelectChange,
  setSearchModel
}) => {
  const [patientSuperSearchValue, setPatientSuperSearchValue] = useState("");
  const [activeElement, setActiveElement] = useState(null);
  const [tagPopup, setTagPopup] = useState(false);
  const [taskPopup, setTaskPopup] = useState(false);
  const [confirmActivePatient, setConfirmActivePatient] = useState(false);
  const [filtersList, setFiltersList] = useState({
    patientAccountNum: [],
    primaryInsurance: [],
    secondaryInsurance: [],
    tags: []
  })

  const dispatch = useDispatch();

  const changeStatus = async () => {
    try {
      setLoading(true);
      const activePatientsArray = Array.from(selectedRows);
      const response = await api.post(`${process.env.REACT_APP_TC_PMS}/api/Patient/ReactivateArchivedPatient`, activePatientsArray);
      toast.success(response.data.responseMessage);
      handleSearchPatient("cancel", 1, 20);
      setConfirmActivePatient(false);
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectedPayer = (selectedObj, type) => {
    if (selectedObj) {
      setSearchModel((prev) => ({
        ...prev,
        [type]: selectedObj.value,
      }));
    } else {
      setSearchModel((prev) => ({
        ...prev,
        [type]: '',
      }));
    }
  };

  const handleClear = () => {
    handleSearchPatient("cancel", 1, 20)
  }

  // ********************* TagPopup Function Start ****************
  const closeTagPopup = () => { setTagPopup(false); };
  const openTagPopup = () => { setTagPopup(true); };

  // ***************************** CreateTaskPopup Function Start ***************
  const openTaskPopup = (row) => { setTaskPopup(true); };
  const closeTaskPopup = (row) => { setTaskPopup(false); };

  // **************************** SuperAccordion Functions Start ****************************
  const handleToggle = (element) => {
    if (activeElement === element) {
      setActiveElement(null); // Close the accordion
    } else {
      setActiveElement(element); // Open the accordion
    }
  };

  // ************************ SuperSearch Patient Funciton Start ************
  const handleSelectedData = (selectedObj) => {
    if (selectedObj) {
      setPatientSuperSearchValue(selectedObj.name);
      if (parentTab === "tasks") {
        setPatientSuperSearchId(selectedObj.id);
      } else {
        const obj = {
          active: true,
          id: selectedObj.id,
          accountNum: selectedObj.accountNum,
          subTab: "Overview",
          name: selectedObj.name,
          unsavedChanges: false,
          insuranceData: { status: false, editMode: false },
        };
        dispatch(addPatient(obj));
      }
    } else {
      setPatientSuperSearchValue("");
      if (parentTab === "tasks") {
        setPatientSuperSearchId(null);
      }
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Patient/FindPatientFiltersSnapshot`);
        const dataModel = response?.data?.dataModel || {};
        setFiltersList({
          patientAccountNum: dataModel.patientAccountNum || [],
          primaryInsurance: dataModel.primaryInsurance || [],
          secondaryInsurance: dataModel.secondaryInsurance || [],
          tags: dataModel.tags || [],
        });
      } catch (error) {
        ErrorHandlingMessage(error)
      }
    })();
    if (!activeTab) {
      setPatientSuperSearchValue("");
    }
  }, [activeTab]);
  return (
    <div className="mb-4" id='patientSearchGridForm'>
      <Show when={taskPopup}>
        <CreateTaskPopup onClose={closeTaskPopup} patientInfo={taskRowsData} />
      </Show>
      <Show when={tagPopup}>
        <AddNewTagPopup onClose={closeTagPopup} tagId={0} allowActive={false} />
      </Show>
      <Show when={confirmActivePatient}>
        <ConfirmationPopup
          buttonTitle="Yes"
          onCancel={() => setConfirmActivePatient(false)}
          onConfirm={changeStatus}
          subHeading="Are you sure you want to unarchive the selected patients?"
        />
      </Show>
      <div className="flex justify-between ">
        <div className="flex items-center w-[355px] ">
          <PatientFilterSuperSearch
            handleSelectedData={handleSelectedData}
            superSearchPatientValue={patientSuperSearchValue}
            setSuperSearchPatientValue={setPatientSuperSearchValue}
            filterCount={filterCount}
            handleToggle={handleToggle}
            activeElement={activeElement}
          />
        </div>
        <Show when={parentTab !== "tasks"}>
          <div className="flex gap-4">
            <Show when={selectedRows.size > 0}>
              <div className='flex items-center justify-center h-full'>
                <Dropdown>
                  <Dropdown.Button className="[&[data-state=open]_button]:border-primaryColor [&[data-state=open]_button]:text-primaryColor [&[data-state=open]_button_svg]:text-primaryColor">
                    <button type="button" className="flex items-center justify-between gap-2 px-3 py-2 text-sm font-medium leading-4 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:border-primaryColor">
                      Actions
                      <FiChevronDown size={15} />
                    </button>
                  </Dropdown.Button>
                  <Dropdown.Menu>
                    <Dropdown.MenuItem onSelect={() => openTagPopup()} className="group rdx_item" >Add Tag</Dropdown.MenuItem>
                    <Dropdown.MenuItem onSelect={() => openTaskPopup()} className="group rdx_item" >Create Task</Dropdown.MenuItem>
                    <Show when={searchModel.patientStatus === "archived"}>
                      <Dropdown.MenuItem onSelect={() => setConfirmActivePatient(true)} className="group rdx_item" >Unarchive Patient</Dropdown.MenuItem>
                    </Show>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Show>
            <ExportToEmail
              model={{
                ...paramModel,
                isExportCall: true,
                isExportToMailCall: true,
                param_list: ParamListGen(searchModel),
              }}
              API={`${process.env.REACT_APP_TC_PMS}/api/Patient/2.0/FindPatients`}
              fileName="Email Excel Sheet"
              subHeading="Send a link to this Excel sheet to your registered email address."
            />
            <ExportExcel
              model={{
                ...paramModel,
                isExportCall: true,
                param_list: ParamListGen(searchModel),
              }}
              API={`${process.env.REACT_APP_TC_PMS}/api/Patient/FindPatient`}
              fileName="Patient Report"
              subHeading="Are you sure you want to download Patient Report?"
            />
            <CustomButtonNew label="Add Patient" onClick={() => setNewPatientPopup(true)} prefixIcon={<PlusIcon />} />
          </div>
        </Show>
      </div>
      <SuperAccordion show={activeElement === 0}>
        <div className="grid gap-4 pt-8 pb-4 grid-cols-24 ">
          <div className="col-span-4 md:col-span-6 xl:col-span-4 ">
            <AccountNumSuperSearch
              label="Account #"
              placeholder="Account #"
              customData={filtersList.patientAccountNum}
              handleSelectedData={(val) => handleSelectedPayer(val, 'accountNum')}
              onKeyPress={handleEnter}
              onChange={(val) =>
                setSearchModel((prev) => ({
                  ...prev,
                  accountNum: val,
                }))
              }
              searchValue={searchModel.accountNum}
            />
          </div>
          <div className="col-span-4 md:col-span-6 xl:col-span-4 ">
            <CustomInput label="DOB" name="dob" max={TODAY_DATE} type="date" value={searchModel.dob} onChange={handleSearchModel} onKeyPress={handleEnter} />
          </div>
          <div className="col-span-4 md:col-span-6 xl:col-span-4 ">
            <CustomSelect label="Gender" name="gender" value={searchModel.gender} onKeyPress={handleEnter} onChange={handleSearchModel}  >
              {GENDER_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>))}
            </CustomSelect>
          </div>

          <div className="col-span-4 md:col-span-6 xl:col-span-4 ">
            <CustomSelect label="Status" name="patientStatus" value={searchModel.patientStatus} onKeyPress={handleEnter} onChange={handleSearchModel} >
              {PATIENT_STATUS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>))}
            </CustomSelect>
          </div>
          <div className="col-span-4 md:col-span-6 xl:col-span-4">
            <CustomDateRangePicker
              label="Created Date Range"
              name="createdDateRange"
              startDateName="dateFrom"
              endDateName="dateTo"
              startDate={searchModel.dateFrom}
              endDate={searchModel.dateTo}
              onChange={handleSearchModel}
              onKeyPress={handleEnter}
              maxDate={TODAY_DATE}
              placeholder="Select date range"
            />
          </div>
          <div className="col-span-4 md:col-span-6 xl:col-span-4">
            <CustomInput
              label="Phone Number"
              name="PHONENUMBER"
              placeholder="Phone Number"
              value={MaskPhoneNumber(searchModel.PHONENUMBER, "generatemask")}
              onChange={handleSearchModel}
              onKeyPress={handleEnter}
            />
          </div>
          <div className="col-span-4 md:col-span-6 xl:col-span-4">
            <CustomInput
              label="Email"
              name="EMAIL"
              onKeyPress={handleEnter}
              onChange={handleSearchModel}
              value={searchModel.EMAIL}
              placeholder="Email"
            />
          </div>
          <div className="col-span-4 md:col-span-6 xl:col-span-4">
            <CustomInput label="Zip Code" maxlength="9" isNumeric name="zipCode" onInput={onPasteZip} value={searchModel.zipCode} onChange={handleSearchModel} onKeyPress={handleEnter} placeholder="Zip Code" />
            {validationModel.zipCodeError}
          </div>
          <div className="flex flex-col col-span-4 gap-2 md:col-span-6 xl:col-span-5 ">
            <CustomLabel label='Balance' />
            <div className="flex">
              <CustomSelect name="balanceCondition" value={searchModel.balanceCondition} onChange={handleSearchModel} wrapperClass='!w-36 focus-outline-none' >
                <option>Under</option>
                <option>Over</option>
              </CustomSelect>
              <CustomInput placeholder="Balance" isNumeric name="balanceAmount" value={searchModel.balanceAmount} onChange={handleSearchModel} onKeyPress={handleEnter} />
            </div>
          </div>
          <div className="flex flex-col col-span-4 gap-2 md:col-span-6 xl:col-span-7">
            <CustomLabel label='Credit' />
            <div className="flex">
              <CustomSelect name="creditCondition" value={searchModel.creditCondition} onChange={handleSearchModel} wrapperClass='!w-36' >
                <option>Under</option>
                <option>Over</option>
              </CustomSelect>
              <CustomInput isNumeric name="creditAmount" placeholder="Credit" value={searchModel.creditAmount} onChange={handleSearchModel} onKeyPress={handleEnter} />
            </div>
          </div>
          <div className="flex flex-col col-span-4 gap-2 md:col-span-4 xl:col-span-8">
            <CustomLabel label='Primary Payer' />
            <Select
              isMulti
              name="primaryPayer"
              options={filtersList.primaryInsurance}
              onChange={(options) => handlemultiSelectChange(options, 'primaryPayer')}
              value={filtersList.primaryInsurance.filter(opt =>
                searchModel.primaryPayer.split(",").map(Number).includes(opt.value)
              )}
              className="custom-react-select-container"
              classNamePrefix="custom-react-select"
              components={{ Option: CustomReactSelectOptions }}
            />
          </div>
          <div className="flex flex-col col-span-4 gap-2 md:col-span-6 xl:col-span-8">
            <CustomLabel label='Sec. Payer' />
            <Select
              isMulti
              name="secondaryPayer"
              options={filtersList.secondaryInsurance}
              onChange={(options) => handlemultiSelectChange(options, 'secondaryPayer')}
              value={filtersList.secondaryInsurance.filter(opt =>
                searchModel.secondaryPayer.split(",").map(Number).includes(opt.value)
              )}
              className="custom-react-select-container"
              classNamePrefix="custom-react-select"
              components={{ Option: CustomReactSelectOptions }}
            />
            {/* <MultiSelectDropdown
              options={filtersList.secondaryInsurance}
              // selectedOptions={primaryInsurances}

              selectedOptions={filtersList.secondaryInsurance.filter((opt) => searchModel.secondaryPayer.split(',').map(Number).includes(opt.value))}
              getSelectedValue={(options) => handlemultiSelectChange(options, 'secondaryPayer')}
              placeholder='Choose status options...'
              className='w-full'
            /> */}
          </div>
          <div className="flex flex-col col-span-4 gap-2 md:col-span-6 xl:col-span-8">
            <CustomLabel label='Tag' />
            <Select
              isMulti
              name="tag"
              options={filtersList.tags}
              onChange={(options) => handlemultiSelectChange(options, 'tag')}
              value={filtersList.tags.filter(opt =>
                searchModel.tag.split(",").map(Number).includes(opt.value)
              )}
              className="custom-react-select-container"
              classNamePrefix="custom-react-select"
              components={{ Option: CustomReactSelectOptions }}
            />
          </div>
          <div className="flex items-end justify-end gap-4 col-span-24 ">
            <CustomButtonNew variant="outline" onClick={handleClear} label="Clear" />
            <CustomButtonNew onClick={() => handleSearchPatient("", 1, 20)} label="Search" />
          </div>
        </div>
      </SuperAccordion>
    </div>
  )
}

export default PatientSearchForm